import {HttpMethod} from './ServerApi';

/**
 * Max number of items in cache.
 */
const CACHE_LENGTH = 20;
/**
 * Cache entry lifetime (ms).
 */
const CACHE_LIFETIME = 300000;

/**
 * Cache items list.
 */
const list = new Array<RequestCacheItem>( CACHE_LENGTH );
/**
 * Last item in cache.
 */
let tail: number = -1;

/**
 * Add request to cache.
 * 
 * @param response Parsed server response.
 * @param method HTTP method.
 * @param path The path to request within API.
 * @param data Data to send to the server.
 * @param contentType Content type.
 */
function add(
	response: Promise<any>,
	method: HttpMethod,
	path: string,
	data: any = null,
	contentType?: string,
): void
{
	tail = tail + 1;
	
	if ( tail >= CACHE_LENGTH )
	{
		tail = 0;
	}
	
	list[tail] = {
		method,
		path,
		data,
		contentType,
		response,
		timestamp: Date.now(),
	};
}

/**
 * Get parsed server response for reqest from cache.
 * 
 * @param method HTTP method.
 * @param path The path to request within API.
 * @param data Data to send to the server.
 * @param contentType Content type.
 */
function get(
	method: HttpMethod,
	path: string,
	data: any = null,
	contentType?: string,
): Promise<any> | null
{
	if ( tail === -1 )
	{
		return null;
	}
	
	for ( let i = 0; i < CACHE_LENGTH; i++ )
	{
		let index: number = tail - i;
		
		if ( index < 0 )
		{
			index = CACHE_LENGTH + index;
		}
		
		const request = list[index];
		
		if (
			request
			&& ( request.method === method )
			&& ( request.path === path )
			&& ( request.data === data )
			&& ( request.contentType === contentType )
			&& ( (Date.now() - request.timestamp) < CACHE_LIFETIME )
		)
		{
			return request.response;
		}
	}
	
	return null;
}

/**
 * Request cache item.
 */
interface RequestCacheItem
{
	method: HttpMethod;
	path: string;
	data: any;
	contentType: string | undefined;
	response: Promise<any>;
	timestamp: number;
}

/**
 * Module.
 */
export {
	add,
	get,
	RequestCacheItem,
};



// WEBPACK FOOTER //
// ./app/utils/RequestCache.ts